import { Moment } from 'moment';
import { useAppContext } from '../../../Services/AppContext';
import {
	HealthPlanUserItem,
	useLazyEventQuery,
} from '../../../graphql/graphql';
import { useHealthPlanContext } from '../../../Services/HealthPlanContext';
import { ItemType } from '../../../Enums/ItemType.enum';
import moment from 'moment';

export default function useHealthPlanAppointment() {
	const { dateFormatMoment } = useAppContext();
	const [getEvent] = useLazyEventQuery();

	const getDateRangeByMonth = (activeFrom: Moment, month: number) => {
		if (!activeFrom || !month) {
			return null;
		}
		const from = activeFrom
			.clone()
			.add(month - 1, 'month')
			.format(dateFormatMoment);
		const to = activeFrom.clone().add(month, 'month').format(dateFormatMoment);
		return `${from} - ${to}`;
	};

	const getNextBabyAppointmentDate = async (
		lastAppointment?: HealthPlanUserItem,
		nextAppointment?: HealthPlanUserItem,
	) => {
		let newEventDate = '';

		if (lastAppointment && nextAppointment) {
			if (
				lastAppointment?.extra?.eventId &&
				nextAppointment?.extra?.frequencyDaysAfterPrevious
			) {
				const event = await getEvent({
					id: lastAppointment.extra.eventId,
				});

				const eventDate = moment(event?.data?.event?.dateFrom);
				newEventDate = eventDate
					.clone()
					.add(nextAppointment.extra.frequencyDaysAfterPrevious, 'days')
					.format(dateFormatMoment);
			}
		}

		return newEventDate;
	};

	const getNextAppointmentInfo = () => {
		const { healthPlanData } = useHealthPlanContext();
		let appointment: any = null;

		if (healthPlanData) {
			healthPlanData.map((item: any) => {
				item.children.map((child: any) => {
					if (child.type === ItemType.APPOINTMENT) {
						if (
							!appointment &&
							!child.extra.eventId &&
							child.extra.status != 'completed'
						) {
							appointment = child;
						}
					}
				});
			});
		}

		return appointment;
	};

	const getLastPlannedAppointmentInfo = () => {
		const { healthPlanData } = useHealthPlanContext();
		let appointment: any = null;

		if (healthPlanData) {
			healthPlanData.map((item: any) => {
				item.children.map((child: any) => {
					if (child.type === ItemType.APPOINTMENT) {
						if (child.extra.eventId) {
							appointment = child;
						}
					}
				});
			});
		}

		return appointment;
	};

	return {
		getDateRangeByMonth,
		getNextAppointmentInfo,
		getLastPlannedAppointmentInfo,
		getNextBabyAppointmentDate,
	};
}
